export class ALARM {
    Type: string = "ALARM";
    SerialNumber: string;
    Status: number;
    DeviceName: string;
    Name: string;
    Description: string;
    AlarmConfId: number;
    StartDate: Date;
    EndDate: Date;
}